{
  "familyId": "TIJD-DIAGRAM",
  "questions": [
    {
      "id": "TIJD-DIAGRAM-001",
      "familyId": "TIJD-DIAGRAM",
      "module": "Tijd",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_diagram",
      "questionType": "multiple_choice",
      "question": "In een tijddiagram zie je dat een trein om 08:15 vertrekt en om 09:45 aankomt. Hoe lang duurt de reis?",
      "options": ["1 uur en 30 minuten", "1 uur en 15 minuten", "2 uur en 30 minuten", "1 uur en 45 minuten"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdsduur berekenen",
            "content": "Reken van vertrektijd naar aankomsttijd. Van 08:15 naar 09:15 = 1 uur. Van 09:15 naar 09:45 = 30 minuten. Totaal: 1 uur en 30 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_diagram_duur",
      "variantIndex": 1,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Van 08:15 naar 09:15 = 1 uur. Van 09:15 naar 09:45 = 30 minuten. Totaal: 1 uur en 30 minuten.",
        "solutionSteps": [
          "Vertrektijd: 08:15",
          "Aankomsttijd: 09:45",
          "08:15 → 09:15 = 1 uur",
          "09:15 → 09:45 = 30 minuten",
          "Totaal: 1 uur en 30 minuten"
        ],
        "distractorExplanations": {
          "0": "Goed! Van 08:15 naar 09:45 = 1 uur en 30 minuten.",
          "1": "Je dacht waarschijnlijk dat 45 − 15 = 30 en dan 1 uur en 15 minuten. Maar 45 − 15 = 30 minuten, plus 1 uur = 1 uur en 30 minuten. Onthoud: reken eerst de uren, dan de minuten.",
          "2": "Je dacht waarschijnlijk dat het verschil 2,5 uur is. Maar van 08:15 naar 09:45 is maar 1,5 uur. Onthoud: 08 naar 09 = 1 uur, niet 2.",
          "3": "Je dacht waarschijnlijk dat 45 + 15 = 60 minuten = 1 uur en 45 minuten. Maar je moet aftrekken, niet optellen: 45 − 15 = 30 minuten. Onthoud: trek de vertrektijd af van de aankomsttijd."
        }
      }
    },
    {
      "id": "TIJD-DIAGRAM-002",
      "familyId": "TIJD-DIAGRAM",
      "module": "Tijd",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_diagram",
      "questionType": "multiple_choice",
      "question": "Een tijddiagram toont dat bus A om 07:30 vertrekt en bus B om 07:50. Bus A doet 40 minuten over de route, bus B doet 25 minuten. Welke bus komt het eerst aan?",
      "options": ["Bus B (om 08:15)", "Bus A (om 08:10)", "Ze komen tegelijk aan", "Bus A (om 08:15)"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aankomsttijd berekenen",
            "content": "Bereken de aankomsttijd van elke bus apart. Bus A: 07:30 + 40 min = 08:10. Bus B: 07:50 + 25 min = 08:15. Vergelijk de aankomsttijden.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_diagram_vergelijken",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bus A: 07:30 + 40 min = 08:10. Bus B: 07:50 + 25 min = 08:15. Bus A komt 5 minuten eerder aan dan bus B.",
        "solutionSteps": [
          "Bus A: 07:30 + 40 min = 08:10",
          "Bus B: 07:50 + 25 min = 08:15",
          "08:10 is eerder dan 08:15",
          "Antwoord: Bus A komt eerst aan (om 08:10)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat bus B eerder aankomt omdat die sneller is (25 min vs 40 min). Maar bus B vertrekt 20 minuten later. 07:50 + 25 = 08:15, terwijl 07:30 + 40 = 08:10. Onthoud: kijk naar de aankomsttijd, niet alleen de reistijd.",
          "1": "Goed! Bus A vertrekt om 07:30, doet 40 minuten, en komt aan om 08:10.",
          "2": "Je dacht waarschijnlijk dat ze tegelijk aankomen. Maar bus A komt om 08:10 en bus B om 08:15 — dat is 5 minuten verschil. Onthoud: bereken beide aankomsttijden apart.",
          "3": "Je hebt de aankomsttijd van bus A goed berekend (08:10), maar je hebt de verkeerde bus gekozen bij 08:15. Bus A = 08:10, bus B = 08:15. Onthoud: lees de antwoorden goed."
        }
      }
    },
    {
      "id": "TIJD-DIAGRAM-003",
      "familyId": "TIJD-DIAGRAM",
      "module": "Tijd",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_diagram",
      "questionType": "multiple_choice",
      "question": "Een tijddiagram toont de temperatuur per uur. Om 06:00 is het 8°C, om 12:00 is het 18°C, om 18:00 is het 14°C. Wanneer was de temperatuurstijging het grootst?",
      "options": ["Tussen 06:00 en 12:00", "Tussen 12:00 en 18:00", "Tussen 06:00 en 18:00", "De temperatuur steeg niet"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stijging aflezen uit een diagram",
            "content": "Vergelijk het verschil per periode. 06:00→12:00: 18 − 8 = +10°C (stijging). 12:00→18:00: 14 − 18 = −4°C (daling). De grootste stijging is +10°C.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_diagram_stijging",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Tussen 06:00 en 12:00 steeg de temperatuur van 8°C naar 18°C = +10°C. Tussen 12:00 en 18:00 daalde het van 18°C naar 14°C = −4°C. De grootste stijging was dus 's ochtends.",
        "solutionSteps": [
          "06:00 → 12:00: 18 − 8 = +10°C (stijging)",
          "12:00 → 18:00: 14 − 18 = −4°C (daling!)",
          "Grootste stijging: +10°C (ochtend)"
        ],
        "distractorExplanations": {
          "0": "Goed! De stijging van 8°C naar 18°C (+10°C) was de grootste.",
          "1": "Je dacht waarschijnlijk dat de temperatuur ook 's middags steeg. Maar van 18°C naar 14°C is een daling van 4°C. Onthoud: als het getal kleiner wordt, is het een daling.",
          "2": "Je dacht waarschijnlijk dat je de hele dag moet bekijken. Maar de vraag is per periode. Van 06:00 tot 18:00 steeg het totaal 6°C, maar de stijging per periode was het grootst 's ochtends (+10°C). Onthoud: vergelijk per tijdvak.",
          "3": "Je dacht waarschijnlijk dat de temperatuur niet steeg. Maar van 8°C naar 18°C is een stijging van 10 graden. Onthoud: als het getal groter wordt, is het een stijging."
        }
      }
    },
    {
      "id": "TIJD-DIAGRAM-004",
      "familyId": "TIJD-DIAGRAM",
      "module": "Tijd",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_diagram",
      "questionType": "multiple_choice",
      "question": "In een afstand-tijd diagram legt een fietser in het eerste uur 15 km af en in het tweede uur 10 km. Wat kun je aflezen?",
      "options": ["De fietser ging langzamer in het tweede uur.", "De fietser ging sneller in het tweede uur.", "De fietser stopte in het tweede uur.", "De fietser reed constant."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand-tijd diagram",
            "content": "In een afstand-tijd diagram betekent een steilere lijn = sneller. Een minder steile lijn = langzamer. Een vlakke lijn = stilstand.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_diagram_snelheid",
      "variantIndex": 4,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "In het eerste uur: 15 km. In het tweede uur: 10 km. De fietser legde minder afstand af in dezelfde tijd, dus ging hij langzamer.",
        "solutionSteps": [
          "Uur 1: 15 km afgelegd",
          "Uur 2: 10 km afgelegd",
          "10 km < 15 km in dezelfde tijd",
          "Conclusie: langzamer in het tweede uur"
        ],
        "distractorExplanations": {
          "0": "Goed! 10 km in 1 uur is langzamer dan 15 km in 1 uur.",
          "1": "Je dacht waarschijnlijk dat de fietser sneller ging. Maar 10 km/uur is langzamer dan 15 km/uur. Onthoud: minder afstand in dezelfde tijd = langzamer.",
          "2": "Je dacht waarschijnlijk dat de fietser stopte. Maar hij legde nog steeds 10 km af — hij reed dus wel, maar langzamer. Stoppen = 0 km. Onthoud: stilstand = vlakke lijn in het diagram.",
          "3": "Je dacht waarschijnlijk dat de snelheid gelijk bleef. Maar 15 km/uur ≠ 10 km/uur. Constant rijden zou 15 km in beide uren zijn. Onthoud: constant = dezelfde afstand per uur."
        }
      }
    },
    {
      "id": "TIJD-DIAGRAM-005",
      "familyId": "TIJD-DIAGRAM",
      "module": "Tijd",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_diagram",
      "questionType": "fill_in",
      "question": "Een trein vertrekt om 14:20 en komt aan om 16:05. Hoeveel minuten duurt de reis? Typ het aantal minuten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["105"],
        "caseSensitive": false,
        "placeholder": "... minuten"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdsduur in minuten",
            "content": "Reken in stappen. Van 14:20 naar 15:00 = 40 minuten. Van 15:00 naar 16:00 = 60 minuten. Van 16:00 naar 16:05 = 5 minuten. Totaal: 40 + 60 + 5 = 105 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "tijd_diagram_minuten",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van 14:20 naar 15:00 = 40 minuten. Van 15:00 naar 16:00 = 60 minuten. Van 16:00 naar 16:05 = 5 minuten. Totaal: 40 + 60 + 5 = 105 minuten.",
        "solutionSteps": [
          "14:20 → 15:00 = 40 minuten",
          "15:00 → 16:00 = 60 minuten",
          "16:00 → 16:05 = 5 minuten",
          "Totaal: 40 + 60 + 5 = 105 minuten"
        ]
      }
    }
  ]
}